import { render } from "./Tensorflow.vue?vue&type=template&id=79701ea2&bindings={\"imgRef\":\"setup\",\"result\":\"setup\",\"detect\":\"setup\",\"isLoading\":\"setup\",\"openCamera\":\"setup\",\"videoRef\":\"setup\",\"isStreaming\":\"setup\",\"stopStreaming\":\"setup\",\"snapshot\":\"setup\"}"
import script from "./Tensorflow.vue?vue&type=script&lang=js"
export * from "./Tensorflow.vue?vue&type=script&lang=js"
script.render = render

export default script